import * as Cookies from 'js-cookie';
import { TypedReducer } from 'redoodle';
import { ApiLogoutUserAction } from '../actions/apiActions';
import { NewUserApi } from '../actions/plaidActions';
import { AuthState } from '../store/AppState';

const builder = TypedReducer.builder<AuthState>();

builder.withHandler(ApiLogoutUserAction.TYPE, () => {
  Cookies.remove('BRIGIT_SITE_TOKEN');
  return { token: null, registered: false };
});

builder.withHandler(NewUserApi.SUCCESS.TYPE, (state, payload) => {
  Cookies.set('BRIGIT_SITE_TOKEN', payload.token);
  return { token: payload.token, registered: true };
});

export default builder.build();
